import React, { useEffect } from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "./GalleryPlayer.css";

const GalleryPlayer = (props) => {
    const getItems = () => {
        return props.offer[0]?.galleryShows[props.galleryId]?.playlist.map(
            (item, i) => {
                const colClass = i % 5 === 0 ? "zl_col_12" : "zl_col_6";
                return (
                    <a key={item.fileId} className={"gallery-item " + colClass} data-src={item.mediaUrl} href={item.mediaUrl}>
                        <img className="img-responsive" src={item.mediaUrl} alt="media" />
                    </a>
                );
            }
        );
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="zl_mainbody_right_content">
            <div className="zl_full_video_section">
                <h1 className="zl_page_main_heading">
                    {props.offer[0]?.galleryShows[props.galleryId]?.title}
                </h1>
                <div className="zl_galleries_player_heading_back_btn">
                    <h2 className="zl_page_main_sub_heading">GALLERY</h2>
                    <div onClick={() => props.setPage("showGalleries")} className="zl_galleries_player_back_btn">
                        back
                    </div>
                </div>
            </div>
            <div className="zl_image_gallery_section">
                <div className="zl_image_gallery_content" id="lightgallery">
                    <LightGallery plugins={[lgZoom]} thumbnail={true} animateThumb={false} download={false} share={false} mobileSettings={{ controls: false, showCloseIcon: true, download: false, share: false }}>
                        {getItems()}
                    </LightGallery>
                </div>
            </div>
        </div>
    );
};

export default GalleryPlayer;